Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENTER_PRESS = 'ENTER_PRESS';
var SUGGESTION_SELECT = 'SUGGESTION_SELECT';
var CLEAR_VALUE = 'CLEAR_VALUE';
var SEARCH_ICON_CLICK = 'SEARCH_ICON_CLICK';
var causes = {
  ENTER_PRESS: ENTER_PRESS,
  SUGGESTION_SELECT: SUGGESTION_SELECT,
  CLEAR_VALUE: CLEAR_VALUE,
  SEARCH_ICON_CLICK: SEARCH_ICON_CLICK
};
exports.default = causes;